export const formattingMenuModes = {
  formatting: "formatting",
  links: "links",
  snippets: "templates",
};
